<app-traitement-data titre="Pression fixe" [sousTitre]="patient!.tableauDeBord?.pressionFixe?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.pressionFixe?.value ? 'info' : 'warning'">
    {{ (patient!.tableauDeBord?.pressionFixe?.value | pression) ?? 'Pas de donnée' }}
</app-traitement-data>